export const getBaseCurrency = (pair) => pair && pair.split('-')[0]
export const getCounterCurrency = (pair) => pair && pair.split('-')[1]
